export default "__VITE_ASSET__BLOJuiWt__"